import { BusinessError } from '@mews/framework';

const DUPLICATE_ROLE_NAME_ERROR = 'DuplicateRoleNameError';

export const isDuplicateRoleNameError = (error?: Error | null | unknown): error is BusinessError =>
    error instanceof BusinessError && error.isErrorType(DUPLICATE_ROLE_NAME_ERROR);
